import React from "react";
import { X, Plus, Save } from "lucide-react";
import Mo3tiButton from "../../layout/Mo3tiButton";
import ReusableDropdown from "../../../../../components/ReusableDropdown";

const AddAllowanceForm = ({
  t,
  theme,
  currentTheme,
  formStyles,
  showAddForm,
  setShowAddForm,
  newAllowance,
  setNewAllowance,
  handleAddAllowance,
  loading,
  language,
  editingAllowanceId,
}) => {
  const isEditing = !!editingAllowanceId;
  const isOvertime = newAllowance.type === "overtime";

  const Toggle = ({ checked, onChange, label }) => (
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        cursor: "pointer",
        color: currentTheme.colors.textSecondary,
        fontSize: "14px",
        fontWeight: "600",
      }}
    >
      <span
        onClick={() => onChange(!checked)}
        style={{
          width: "44px",
          height: "24px",
          borderRadius: "999px",
          background: checked
            ? currentTheme.colors.success
            : currentTheme.colors.border,
          position: "relative",
          transition: "all 0.2s ease",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: "absolute",
            top: "2px",
            left: checked ? "22px" : "2px",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            background: "#fff",
            transition: "all 0.2s ease",
          }}
        />
      </span>
      {label}
    </label>
  );

  return (
    <>
      {/* Add Allowance Form */}
      <div style={formStyles.section}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3
            style={{
              margin: 0,
              color: theme === "dark" ? "#ffffff" : "#1a1a1a",
              fontSize: "20px",
              fontWeight: "700",
            }}
          >
            {isEditing
              ? t("editAllowance") || "Edit Allowance"
              : t("addAllowance") || "Add Allowance"}
          </h3>
          <Mo3tiButton
            variant="secondary"
            icon={showAddForm ? X : Plus}
            onClick={() => setShowAddForm(!showAddForm)}
          >
            {showAddForm
              ? t("cancel")
              : isEditing
              ? t("editAllowance") || "Edit Allowance"
              : t("addAllowance") || "Add Allowance"}
          </Mo3tiButton>
        </div>

        {showAddForm && (
          <div>
            {/* Amount Type — Modern Segmented Control */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{ ...formStyles.label, marginBottom: "8px", display: "block" }}>
                {t("amountType") || "Amount Type"}
              </label>
              <div
                style={{
                  display: "flex",
                  background: theme === "dark" ? "#2a2a2a" : "#f1f5f9",
                  padding: "4px",
                  borderRadius: "8px",
                  width: "100%",
                }}
              >
                <button
                  type="button"
                  onClick={() => setNewAllowance({ ...newAllowance, isTaxable: true })}
                  style={{
                    flex: 1,
                    padding: "8px 0",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: newAllowance.isTaxable ? "600" : "500",
                    fontSize: "13px",
                    transition: "all 0.2s",
                    background: newAllowance.isTaxable ? (theme === "dark" ? "#3b82f6" : "#ffffff") : "transparent",
                    color: newAllowance.isTaxable ? (theme === "dark" ? "#ffffff" : "#0f172a") : (theme === "dark" ? "#94a3b8" : "#64748b"),
                    boxShadow: newAllowance.isTaxable ? (theme === "dark" ? "none" : "0 1px 3px rgba(0,0,0,0.1)") : "none",
                  }}
                >
                  {language === "ar" ? "إجمالي (Gross)" : "Gross"}
                </button>
                <button
                  type="button"
                  onClick={() => setNewAllowance({ ...newAllowance, isTaxable: false })}
                  style={{
                    flex: 1,
                    padding: "8px 0",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: !newAllowance.isTaxable ? "600" : "500",
                    fontSize: "13px",
                    transition: "all 0.2s",
                    background: !newAllowance.isTaxable ? (theme === "dark" ? "#3b82f6" : "#ffffff") : "transparent",
                    color: !newAllowance.isTaxable ? (theme === "dark" ? "#ffffff" : "#0f172a") : (theme === "dark" ? "#94a3b8" : "#64748b"),
                    boxShadow: !newAllowance.isTaxable ? (theme === "dark" ? "none" : "0 1px 3px rgba(0,0,0,0.1)") : "none",
                  }}
                >
                  {language === "ar" ? "صافي (Net)" : "Net"}
                </button>
              </div>
              <p style={{ margin: "6px 0 0 4px", fontSize: "12px", color: theme === "dark" ? "#94a3b8" : "#64748b" }}>
                {newAllowance.isTaxable
                  ? (language === "ar" ? "يُضاف للدخل الخاضع للضريبة." : "Added to taxable income.")
                  : (language === "ar" ? "يُضاف للصافي بعد اقتطاع الضرائب." : "Added to final net after taxes.")}
              </p>
              {newAllowance.isTaxable && (
                <p
                  style={{
                    margin: "6px 0 0 4px",
                    fontSize: "12px",
                    color: currentTheme.colors.textSecondary,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "6px",
                  }}
                >
                  <span aria-hidden="true">ℹ</span>
                  {language === "ar"
                    ? "المبلغ المُدخل هنا إجمالي. سيُحسب أثره الحقيقي على الصافي بعد الضريبة والتأمينات، وسيُخزَّن ذلك المبلغ الأصغر (الصافي المكافئ) في السجل."
                    : "The amount entered here is Gross. It'll be grossed up onto the salary, converted back to net, and the resulting smaller net-equivalent amount is what gets stored and shown afterward."}
                </p>
              )}
            </div>
            <div style={formStyles.formGrid}>
              {/* Type */}
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>
                  {t("allowanceType") || "Allowance Type"}
                </label>
                <ReusableDropdown
                  items={[
                    { id: "transportation", label: t("transportation") || "Transportation" },
                    { id: "housing", label: t("housing") || "Housing" },
                    { id: "meal", label: t("meal") || "Meal" },
                    { id: "variable", label: t("variable") || "Variable" },
                    { id: "overtime", label: t("overtime") || "Overtime" },
                    { id: "bonus", label: t("bonus") || "Bonus" },
                    { id: "commission", label: t("commission") || "Commission" },
                    { id: "representation", label: t("representation") || "Representation" },
                    // ── The rest of the types the bulk-import template and
                    // backend already recognize (see exportAllowanceDeductionTemplate
                    // in payrollController.js) — added so every type that can
                    // be imported can also be added here one at a time.
                    { id: "travel", label: t("travel") || "Travel" },
                    { id: "eid_bonus", label: t("eidBonus") || "Eid Bonus" },
                    { id: "ramadan_bonus", label: t("ramadanBonus") || "Ramadan Bonus" },
                    { id: "seasonal_bonus", label: t("seasonalBonus") || "Seasonal Bonus" },
                    { id: "achievement", label: t("achievement") || "Achievement" },
                    { id: "kpi", label: t("kpi") || "KPI" },
                    { id: "kpi_adjustment", label: t("kpiAdjustment") || "KPI Adjustment" },
                    { id: "incentive", label: t("incentive") || "Incentive" },
                    { id: "sales_incentive", label: t("salesIncentive") || "Sales Incentive" },
                    { id: "metry", label: t("metry") || "Metry" },
                    { id: "phone_bill", label: t("phoneBill") || "Phone Bill" },
                    { id: "trp", label: t("trp") || "TRP" },
                    { id: "system_subscription", label: t("systemSubscription") || "System Subscription" },
                    { id: "service", label: t("service") || "Service" },
                    { id: "settlement", label: t("settlement") || "Settlement" },
                    { id: "retroactive_pay", label: t("retroactivePay") || "Retroactive Pay" },
                    { id: "performance", label: t("performance") || "Performance" },
                    { id: "holiday_compensation", label: t("holidayCompensation") || "Holiday Compensation" },
                    { id: "guarantee", label: t("guarantee") || "Guarantee" },
                    { id: "expenses", label: t("expenses") || "Expenses" },
                    { id: "referral_program", label: t("referralProgram") || "Referral Program" },
                    { id: "e_cash_winner", label: t("eCashWinner") || "E-Cash Winner" },
                    { id: "aman_card_refund", label: t("amanCardRefund") || "Aman Card Refund" },
                    { id: "amen_gebak_refund", label: t("amenGebakRefund") || "Amen Gebak Refund" },
                    { id: "adjustment", label: t("adjustment") || "Adjustment" },
                    { id: "other", label: t("other") },
                  ]}
                  value={newAllowance.type || ""}
                  onChange={(val) => {
                    if (val) setNewAllowance({ ...newAllowance, type: val });
                  }}
                  onSelect={(item) =>
                    setNewAllowance({ ...newAllowance, type: item.id })
                  }
                  placeholder={t("selectType")}
                  theme={theme}
                  language={language}
                  maxItems={40}
                  getItemKey={(item) => item.id}
                  getItemLabel={(item) => item.label}
                  showAllOnArrowClick={true}
                  showClear={true}
                  onClear={() =>
                    setNewAllowance({
                      ...newAllowance,
                      type: "",
                      amount: "",
                      description: "",
                    })
                  }
                  inputStyle={formStyles.input}
                />
              </div>

              {/* Amount */}
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>{t("amount")}</label>
                <input
                  type="number"
                  style={formStyles.input}
                  value={newAllowance.amount}
                  onChange={(e) =>
                    setNewAllowance({ ...newAllowance, amount: e.target.value })
                  }
                  placeholder="0.00"
                />
              </div>

              {/* Days OR Hours */}
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>
                  {isOvertime ? t("hours") || "Hours" : t("days")}
                </label>
                <input
                  type="number"
                  style={formStyles.input}
                  value={isOvertime ? newAllowance.hours : newAllowance.days}
                  onChange={(e) => {
                    if (isOvertime) {
                      setNewAllowance({
                        ...newAllowance,
                        hours: e.target.value,
                      });
                    } else {
                      setNewAllowance({
                        ...newAllowance,
                        days: e.target.value,
                      });
                    }
                  }}
                  placeholder="0"
                  step={isOvertime ? "0.5" : "1"}
                />
              </div>
            </div>

            {/* Optional percentage-based calculation */}
            <div style={formStyles.formGrid}>
              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>
                  {t("percentage") || "Percentage %"}
                </label>
                <input
                  type="number"
                  style={formStyles.input}
                  value={newAllowance.percentage}
                  onChange={(e) =>
                    setNewAllowance({
                      ...newAllowance,
                      percentage: e.target.value,
                    })
                  }
                  placeholder="0"
                />
              </div>

              <div style={formStyles.formGroup}>
                <label style={formStyles.label}>
                  {t("baseAmount") || "Base Amount"}
                </label>
                <input
                  type="number"
                  style={formStyles.input}
                  value={newAllowance.baseAmount}
                  onChange={(e) =>
                    setNewAllowance({
                      ...newAllowance,
                      baseAmount: e.target.value,
                    })
                  }
                  placeholder="0.00"
                />
              </div>
            </div>



            {/* Recurring toggle */}
            <div style={{ display: "flex", gap: "32px", flexWrap: "wrap", marginBottom: "20px" }}>
              <Toggle
                checked={!!newAllowance.isRecurring}
                onChange={(v) =>
                  setNewAllowance({ ...newAllowance, isRecurring: v })
                }
                label={t("isRecurring") || "Recurring (monthly)"}
              />
            </div>

            {/* Description */}
            <div style={formStyles.formGroup}>
              <label style={formStyles.label}>{t("description")}</label>
              <textarea
                style={{
                  ...formStyles.input,
                  minHeight: "80px",
                  resize: "vertical",
                }}
                value={newAllowance.description}
                onChange={(e) =>
                  setNewAllowance({
                    ...newAllowance,
                    description: e.target.value,
                  })
                }
                placeholder={t("descriptionPlaceholder")}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <Mo3tiButton
                variant="secondary"
                icon={Save}
                onClick={handleAddAllowance}
                disabled={loading}
              >
                {loading
                  ? t("saving")
                  : isEditing
                  ? t("update") || "Update"
                  : t("saveAllowance") || "Save Allowance"}
              </Mo3tiButton>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AddAllowanceForm;